import type { SettingsSearchRow } from "../settings-search-types";

/** Anchor ids for the Security & access page's rows — shared by the page and
 *  the search catalog (see rows/preferences.ts). */
export const ACCESS_ANCHORS = {
  password: "password",
  apiKeys: "api-keys",
} as const;

export const ACCESS_SEARCH_ROWS: readonly SettingsSearchRow[] = [
  {
    anchor: ACCESS_ANCHORS.password,
    label: "Password",
    keywords: ["change password", "sign in", "login", "security"],
  },
  {
    anchor: ACCESS_ANCHORS.apiKeys,
    label: "Personal API keys",
    keywords: ["token", "api key", "integration"],
    // The page is open to all (it carries account security), but this
    // section only renders with the integrations permission — the row gate
    // must match or the jump lands on a page without the row.
    permKey: "workspace.integrations",
  },
];
